module.exports = __webpack_public_path__ + "img/電気回路_6_2_4.a1c181e3.png";